import { api, ApiError } from "../api-client.js";

// 002 §7 화면1: 로그인. 5회 실패 시 15분 잠금 안내(서버가 ACCOUNT_LOCKED로 응답).
export function renderLogin(root: HTMLElement, onSuccess: () => void): void {
  root.innerHTML = "";
  const screen = document.createElement("div");
  screen.className = "login-screen";

  const box = document.createElement("div");
  box.className = "login-box";
  box.innerHTML = `
    <h1>JaTem 관제시스템</h1>
    <form id="login-form">
      <div class="field">
        <label for="username">아이디</label>
        <input id="username" name="username" type="text" autocomplete="username" required />
      </div>
      <div class="field">
        <label for="password">비밀번호</label>
        <input id="password" name="password" type="password" autocomplete="current-password" required />
      </div>
      <button type="submit" class="btn-primary" id="login-submit">로그인</button>
      <div class="error-text" id="login-error" style="display:none"></div>
    </form>
  `;
  screen.appendChild(box);
  root.appendChild(screen);

  const form = box.querySelector<HTMLFormElement>("#login-form")!;
  const errorEl = box.querySelector<HTMLDivElement>("#login-error")!;
  const submitBtn = box.querySelector<HTMLButtonElement>("#login-submit")!;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    errorEl.style.display = "none";
    submitBtn.disabled = true;
    submitBtn.textContent = "로그인 중...";

    const formData = new FormData(form);
    const username = String(formData.get("username") ?? "");
    const password = String(formData.get("password") ?? "");

    try {
      await api.post("/api/auth/login", { username, password });
      onSuccess();
    } catch (err) {
      if (err instanceof ApiError) {
        const body = err.body as { error?: string; message?: string } | null;
        if (body?.error === "ACCOUNT_LOCKED") {
          errorEl.textContent = body.message ?? "5회 연속 실패로 15분간 잠겼습니다.";
        } else {
          errorEl.textContent = "아이디 또는 비밀번호가 올바르지 않습니다.";
        }
      } else {
        errorEl.textContent = "로그인 중 오류가 발생했습니다.";
      }
      errorEl.style.display = "block";
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = "로그인";
    }
  });
}
